var map = {
	"./akum_100.png": "FeSt",
	"./akum_100_poziom.png": "Ykwe",
	"./akum_100_poziom_kopia.png": "LVur",
	"./akum_120.png": "8ZwE",
	"./akum_120_poziom.png": "Myzq",
	"./akum_120_poziom_kopia.png": "VcOl",
	"./akum_160.png": "lxOv",
	"./akum_200.png": "Aam/",
	"./akum_230.png": "0HTm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xvyi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator ^\.\/akum_.*\.png$
// module id = xvyi
// module chunks = 1